import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.25 10.25C6.83579 10.25 6.5 10.5858 6.5 11C6.5 11.4142 6.83579 11.75 7.25 11.75H8.75C9.16421 11.75 9.5 11.4142 9.5 11C9.5 10.5858 9.16421 10.25 8.75 10.25H7.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 10.25C10.8358 10.25 10.5 10.5858 10.5 11C10.5 11.4142 10.8358 11.75 11.25 11.75H12.75C13.1642 11.75 13.5 11.4142 13.5 11C13.5 10.5858 13.1642 10.25 12.75 10.25H11.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 11C14.5 10.5858 14.8358 10.25 15.25 10.25H16.75C17.1642 10.25 17.5 10.5858 17.5 11C17.5 11.4142 17.1642 11.75 16.75 11.75H15.25C14.8358 11.75 14.5 11.4142 14.5 11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.25 13.25C6.83579 13.25 6.5 13.5858 6.5 14C6.5 14.4142 6.83579 14.75 7.25 14.75H8.75C9.16421 14.75 9.5 14.4142 9.5 14C9.5 13.5858 9.16421 13.25 8.75 13.25H7.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 14C10.5 13.5858 10.8358 13.25 11.25 13.25H12.75C13.1642 13.25 13.5 13.5858 13.5 14C13.5 14.4142 13.1642 14.75 12.75 14.75H11.25C10.8358 14.75 10.5 14.4142 10.5 14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.25 13.25C14.8358 13.25 14.5 13.5858 14.5 14C14.5 14.4142 14.8358 14.75 15.25 14.75H16.75C17.1642 14.75 17.5 14.4142 17.5 14C17.5 13.5858 17.1642 13.25 16.75 13.25H15.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 17C6.5 16.5858 6.83579 16.25 7.25 16.25H8.75C9.16421 16.25 9.5 16.5858 9.5 17C9.5 17.4142 9.16421 17.75 8.75 17.75H7.25C6.83579 17.75 6.5 17.4142 6.5 17Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 16.25C10.8358 16.25 10.5 16.5858 10.5 17C10.5 17.4142 10.8358 17.75 11.25 17.75H12.75C13.1642 17.75 13.5 17.4142 13.5 17C13.5 16.5858 13.1642 16.25 12.75 16.25H11.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.5 3.25C4.70507 3.25 3.25 4.70507 3.25 6.5V17C3.25 19.0711 4.92893 20.75 7 20.75H17C19.0711 20.75 20.75 19.0711 20.75 17V6.5C20.75 4.70507 19.2949 3.25 17.5 3.25H6.5ZM19.25 7.25V6.5C19.25 5.5335 18.4665 4.75 17.5 4.75H6.5C5.5335 4.75 4.75 5.5335 4.75 6.5V7.25H19.25ZM4.75 8.75H19.25V17C19.25 18.2426 18.2426 19.25 17 19.25H7C5.75736 19.25 4.75 18.2426 4.75 17V8.75Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconDate as ReactComponent };
